import React, { useMemo, useState } from 'react';
import { useApp } from '../context/AppContext';
import { GENRES } from '../mock/mock';
import SongCard from '../components/SongCard';
import { Input } from '../components/ui/input';
import { Search } from 'lucide-react';

export default function Explore() {
  const { t, lang, feed } = useApp();
  const [q, setQ] = useState('');
  const [g, setG] = useState('All');

  const filtered = useMemo(() => {
    return feed.filter(s => {
      const matchG = g === 'All' || (s.genre || '').toLowerCase().includes(g.toLowerCase());
      const title = (s.title?.[lang] || s.title?.en || '');
      const txt = (title + ' ' + (s.artist||'') + ' ' + (s.genre||'')).toLowerCase();
      const matchQ = !q || txt.includes(q.toLowerCase());
      return matchG && matchQ;
    });
  }, [q, g, lang, feed]);

  return (
    <div className="px-4 lg:px-8 py-6 fade-up">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-6">
        <div>
          <h1 className="font-display text-3xl md:text-4xl font-extrabold">{t('explore.title')}</h1>
          <p className="text-zinc-400 text-sm mt-1">{t('explore.subtitle')}</p>
        </div>
        <div className="relative w-full md:w-80">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" />
          <Input value={q} onChange={(e)=>setQ(e.target.value)} placeholder={t('nav.search')} className="pl-9 bg-[#141416] border-white/10" />
        </div>
      </div>

      <div className="flex flex-wrap gap-2 mb-6">
        {['All', ...GENRES].map(x => (
          <button key={x} onClick={()=>setG(x)} className={`pill cursor-pointer ${g===x?'bg-white text-black border-white':'hover:bg-white/10'}`}>{x}</button>
        ))}
      </div>

      {filtered.length === 0 ? (
        <div className="text-sm text-zinc-500 py-16 text-center border border-dashed border-white/10 rounded-2xl">
          {lang==='fr'?'Aucun résultat':'No results'}
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5 gap-4">
          {filtered.map(s => <SongCard key={s.id} song={s} list={filtered} />)}
        </div>
      )}
      <div className="h-32" />
    </div>
  );
}
